export default __webpack_public_path__ + "static/media/detail-icon.f71aee52.svg";